var _polygon, _polygon2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentSvgrepoCom(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    fill: "#90CAF9",
    points: "40,45 8,45 8,3 30,3 40,13"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    fill: "#E1F5FE",
    points: "38.5,14 29,14 29,4.5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#1976D2"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 21,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 25,
    width: 13,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 29,
    width: 17,
    height: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 33,
    width: 13,
    height: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentSvgrepoCom);
export default __webpack_public_path__ + "static/media/document-svgrepo-com.e7cbf984078291969973382099b99f88.svg";
export { ForwardRef as ReactComponent };